import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;

export function useAppConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/config").then((r) => (cache = r.data)).catch(() => (cache = { demo_mode: false, demo_accounts: [] }));
    pending.then(setCfg);
  }, []);
  return cfg;
}
